/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, createTourOperatorSeasonFromDiscriminatorValue, type ProblemDetails, type TourOperatorSeason } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Season/GetForTourOperator
 */
export interface GetForTourOperatorRequestBuilder extends BaseRequestBuilder<GetForTourOperatorRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<TourOperatorSeason[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<GetForTourOperatorRequestBuilderGetQueryParameters> | undefined) : Promise<TourOperatorSeason[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<GetForTourOperatorRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface GetForTourOperatorRequestBuilderGetQueryParameters {
    isActive?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const GetForTourOperatorRequestBuilderUriTemplate = "{+baseurl}/Season/GetForTourOperator?isActive={isActive}";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetForTourOperatorRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: GetForTourOperatorRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createTourOperatorSeasonFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
